var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataAnalysisExamineSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff5e00",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 248 256",
    enableBackground: "new 0 0 248 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118,31v194l128,29V2L118,31z M130,40.59l104-23.57v221.96l-104-23.57V40.59z M2,30v224h39v-30h12 c18.085,0,31.965-15.162,31.965-33.346v-19.666h14.033c3.755,0,6.72-2.965,6.72-6.621c0-0.889-0.099-1.779-0.494-2.569 l-19.468-47.435c0,0-1.779-18.085-3.36-25.002C75.181,58.132,40.751,30,3,30C2.704,30,2.988,30,2,30z M54.824,116.635 c0-4.941,3.953-8.894,8.894-8.894s8.894,3.953,8.894,8.894c0,4.941-3.953,8.894-8.894,8.894S54.824,121.576,54.824,116.635z  M140.146,165.397V96.922l12.736-1.059v70.607l4.449,0.375v-57.466l13.847-0.7v59.333l4.886,0.412v-35.052l15.112,0.082v36.242 l5.298,0.446v-23.248l16.556,0.567v24.075l9.907,0.834V83.875l6.864-0.657v95.449l-97-9.282v-4.516v-0.091L140.146,165.397z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalysisExamineSvgrepoCom);
export default __webpack_public_path__ + "static/media/data-analysis-examine-svgrepo-com.8253b0e87a9eefe4a3a00189a773ee31.svg";
export { ForwardRef as ReactComponent };